import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface MpesaPaymentsSliceObject {
  payments: any[];
}

const initialState: MpesaPaymentsSliceObject = {
  payments: [],
};

const mpesaPaymentsSlice = createSlice({
  name: 'mpesapayments',
  initialState,
  reducers: {
    addMpesaPayments: (state, action: PayloadAction<any[]>) => {
      state.payments = action.payload;
    },
  },
});

export const { addMpesaPayments } = mpesaPaymentsSlice.actions;
export default mpesaPaymentsSlice.reducer;
